import styled from "styled-components"

export const ToolbarWrapper = styled.div`
    position: absolute;
    width: 100%;
    height: 56px;
    top: -56px;
    display: flex;
    background: ${(props) => props.theme.driveToolbarBackgroundColor};
    border-bottom: solid 2px ${(props) => props.theme.driveToolbarBorderColor};

    &.toolbar-on-top {
        position: fixed;
        top: 0;
        height: 63px;
        z-index: 5;
        box-sizing: content-box;
        box-shadow: 0 10px 16px -12px #000;
    }
`
export const ToolbarTotal = styled.div`
    position: relative;
    height: 100%;
    display: flex;
    align-items: center;
    padding: 0 15px 0 20px;

    &::after {
        content: '';
        width: 1px;
        height: 24px;
        background: ${(props) => props.theme.driveToolbarImageColor};
        opacity: 0.24;
        position: absolute;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
    }
`
export const ToolbarActionPanel = styled.div`
    display: flex;
    flex-grow: 1;
    height: 100%;
    padding: 0 10px;
`
export const ToolbarAction = styled.div`
    height: 100%;
    display: flex;
    align-items: center;
    padding: 0 10px;
    cursor: pointer;

    & > i {
        margin-right: 5px;
        color: ${(props) => props.theme.driveToolbarImageColor};
    }

    & > span {
        text-transform: uppercase;
        font-weight: bold;
        font-size: ${(props) => props.theme.fontSizes.xs}px;
        font-family: ${(props) => props.theme.openSans};
        color: ${(props) => props.theme.driveToolbarColor};
    }
`
export const ToolbarClose = styled.div`
    position: relative;
    height: 100%;
    display: flex;
    align-items: center;
    padding: 0 15px 0 15px;
    color: ${(props) => props.theme.driveToolbarCloseButtonColor};
    transition: ${(props) => props.theme.defaultTransition};

    & > i {
        font-weight: 600;
    }

    &:hover {
        color: ${(props) => props.theme.driveToolbarCloseButtonColorHover};
    }

    &::before {
        content: '';
        width: 1px;
        height: 24px;
        background: ${(props) => props.theme.driveToolbarImageColor};
        opacity: 0.24;
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
    }
`
